export default __webpack_public_path__ + "static/media/briefcase.b365cf27.svg";